module.exports = __webpack_public_path__ + "static/media/hair1.e430a725.png";